import {
  Box,
  Divider,
  Grid,
  Paper,
  StyleRules,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { Component } from "react";
import reactImage from "../assets/reactjs.gif";
import qaImage from "../assets/qa.gif";
import rubyImage from "../assets/ruby.gif";
import uiuxImage from "../assets/uiux.gif";
interface Props {
  classes: any;
}
interface State {
  items: itemData[];
}
interface itemData {
  subject: string;
  img: string;
}
class Subjects extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      items: [
        { subject: "UI/UX Design", img: uiuxImage },
        { subject: "ReactJS", img: reactImage },
        { subject: "React-  Native", img: reactImage },
        { subject: "Ruby On Rails", img: rubyImage },
        { subject: "Quality Assurance", img: qaImage },
      ],
    };
  }
  render() {
    const { classes } = this.props;
    // const { items } = this.state;
    return (
      <Grid container className={classes.subjectSectionBody}>
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.titleBody}
        >
          <Typography
            className={classes.title}
            align="center"
            style={{ fontWeight: "700" }}
          >
            Courses Offered
          </Typography>
          <Divider className={classes.subjectDivision} />
        </Grid>
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.cardGridItem}
        >
          <Grid container className={classes.cardGridContainer}>
            {this.state.items.map((item: any) => (
              <Grid
                item
                xl={2}
                lg={2}
                md={2}
                sm={12}
                xs={12}
                className={classes.cards}
              >
                <Paper className={classes.card} elevation={8}>
                  <Box className={classes.subjectBox}>
                    <Typography
                      className={classes.subject}
                      align="center"
                      style={{ fontWeight: "800" }}
                    >
                      {item.subject}
                    </Typography>
                  </Box>
                  <Box className={classes.imageContainer}>
                    <Box className={classes.subjectLogoBox}>
                      <img
                        src={item.img}
                        className={classes.boxImage}
                        alt="img"
                      />
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
        {/* <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.btnGrid}
        >
          <Button
            variant="contained"
            className={classes.btnOutside}
            style={{ fontWeight: "700" }}
          >
            View All
          </Button>
        </Grid> */}
      </Grid>
    );
  }
}
const style: StyleRules = {
  subjectSectionBody: { padding: "10px 20px 10px 10px" },
  titleBody: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "10px 10px 20px 10px !important",
  },
  btnGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px 10px 0px 10px !important",
  },
  title: {
    fontSize: "40px !important",
    fontWeight: 700,
    fontFamily: "Nunito !important",
    lineHeight: "54.56px !important",
    margin: "5px 0 5px 0 !important",
  },
  subjectDivision: {
    width: "328px !important",
    height: "4px !important",
    background: "rgba(247, 119, 171, 1) !important",
    margin: "5px 0 5px 0 !important",
  },
  subject: {
    fontFamily: "Nunito !important",
    fontWeight: 800,
    fontSize: "20px !important",
    lineHeight: "28px !important",
    color: "white !important",
  },
  cardGridItem: {
    margin: "10px 0px 10px 0px !important",
  },
  cardGridContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cards: {
    // padding: "5px 20px 5px 20px",
    display: "flex",
    justifyContent: "space-around",
    minWidth: "185px",
    alignItems: "center",
  },
  card: {
    padding: "6px",
    borderRadius: "22px",
    display: "flex",
    height: "267px",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "227px",
    margin: "5px 5px 5px 5px !important",
  },
  subjectBox: {
    background:
      "linear-gradient(180deg, #EFB6B6 0%, rgba(218, 64, 64, 0.46) 100%)",
    height: "96px",
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "20px",
  },
  imageContainer: {
    margin: "5px",
    width: "100%",
    height: "64%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  subjectLogoBox: {
    display: "flex",
    alignItems: "center",
    width: "133px",
    height: "131px",
    // marginTop: "30px",
  },
  btnOutside: {
    height: "62.28px !important",
    width: "224.22px !important",
    color: "white !important",
    background: "linear-gradient(270deg, #0D6AFC 0%, #074CBA 100%) !important",
    margin: "10px 10px 10px 10px !important",
    fontWeight: 700,
    fontSize: "20px !important",
    fontFamily: "Roboto !important",
    lineHeight: "23.44px !important",
    borderRadius: "6px !important",
  },
  boxImage: { width: "100%", height: "auto" },
  "@media screen and (min-width: 600px) and (max-width: 959px)": {
    titleBody: { marginBottom: "0px !important" },
    cards: {
      display: "flex",
      justifyContent: "center",
    },
    card: {
      flexDirection: "row-reverse",
      height: "auto",
      width: "353px",
    },
    subjectDivision: { display: "none" },
    imageContainer: {
      maxWidth: "30%",
    },
    subjectLogoBox: {
      marginTop: "0px !important",
      maxWidth: "100px",
      maxHeight: "98.5px",
    },
    subjectBox: { marginTop: "0px !important", width: "65%" },
  },
  "@media screen and (min-width: 0px) and (max-width: 599px)": {
    titleBody: { marginBottom: "0px !important" },
    title: { fontSize: "35px !important", margin: "0px !important" },
    subjectDivision: { display: "none" },
    cards: {
      marginBottom: "10px !important",
      justifyContent: "center",
    },
    card: {
      flexDirection: "row-reverse",
      height: "auto",
      width: "353px",
    },
    imageContainer: {
      margin: "0px !important",
      maxWidth: "30%",
    },
    subjectLogoBox: {
      marginTop: "0px !important",
      maxWidth: "100px",
      maxHeight: "98.5px",
    },
    subjectBox: { marginTop: "0px !important", width: "65%" },
  },
};
export default withStyles(style)(Subjects);